import styled from 'styled-components';
import { animated } from '@react-spring/web';
import { status } from '../theme/color';
export const StatLabel = styled.dt `
  color: var(--button-text-color);
  @apply m-0 text-base;
`;
export const StyledStat = styled.dl `
  @apply m-0 p-0;
  background-color: var(--bg-color);
`;
export const StyledStatNumber = styled(animated.dd) `
  color: var(--button-text-color);
  @apply m-0 font-bold text-3xl;
`;
export const StyledStatHelpText = styled.dd `
  color: ${(props) => (props.type ? status[props.type] : 'var(--text-color-2)')};

  @apply m-0 text-base;
`;
